import { useState, useEffect, useRef, useCallback, memo } from "react";
import {
  Box,
  Text,
  Input,
  InputGroup,
  useDisclosure,
  useOutsideClick,
  InputLeftElement,
  FormControl,
} from "@chakra-ui/react";
import Countries from "utils/countryCodes.json";
import { AsYouType } from "libphonenumber-js";
import { SearchOnList } from "./SearchOnList";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import ErrorText from "./shared/typography/ErrorText";

export const PhoneNumberInput = memo(
  ({ onChange, value, errors, placeholder = "Enter mobile phone number" }) => {
    const ref = useRef(null);
    const [number, setNumber] = useState(value);
    const [country, setCountry] = useState("+234");
    const [countryFlag, setCountryFlag] = useState(`🇳🇬`);
    const { isOpen, onToggle, onClose } = useDisclosure();

    useOutsideClick({
      ref: ref,
      handler: () => onClose(),
    });

    useEffect(() => {
      if (country !== "" || number !== "") {
        onChange(`${country}${number}`);
      }
    }, [country, number, onChange]);

    const onCountryChange = useCallback(
      (item) => {
        const parsedNumber = new AsYouType().input(`${country}${number}`);

        setCountry(item?.dial_code);
        setCountryFlag(item?.flag);
        onChange(parsedNumber);
        onClose();
      },
      [country, number, onChange, onClose]
    );

    const onPhoneNumberChange = useCallback(
      (event) => {
        const value = event.target.value;
        const parsedNumber = new AsYouType().input(`${country}${number}`);

        setNumber(value);
        onChange(parsedNumber);
      },
      [country, number, onChange]
    );

    return (
      <FormControl>
        <Box as="section" ref={ref} position="relative">
          <InputGroup>
            <InputLeftElement width="5em" cursor="pointer" onClick={onToggle}>
              <Text as="span" mr={3}>
                {countryFlag}
              </Text>
              {isOpen ? (
                <ChevronUpIcon boxSize={6} color="gray.500" />
              ) : (
                <ChevronDownIcon boxSize={6} color="gray.500" />
              )}
            </InputLeftElement>
            <Input
              pl="5em"
              type="tel"
              value={number}
              placeholder={placeholder}
              onChange={onPhoneNumberChange}
            />
          </InputGroup>

          {isOpen ? (
            <SearchOnList data={Countries} onChange={onCountryChange} />
          ) : null}
        </Box>
        {errors.mobile && <ErrorText text={errors.mobile.message} />}
      </FormControl>
    );
  }
);

PhoneNumberInput.displayName = "PhoneNumberInput";
